import { useEffect, useState } from 'react'

/// Fetch a static JSON file from public/ once per mount, returning `{ data, loading }`. This is the
/// shared shape behind `usePointsData` / `useReserveHistory` / `useVaultNavHistory`: an off-chain
/// indexer writes `public/*.json`, the frontend reads it once (no polling - the file only changes
/// when the indexer is re-run and redeployed). Each hook keeps only its own selector over `data`.
/// A failed / missing file leaves `data` null, so callers render the honest "no data" state.
export function useJsonFile(path, opts) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    fetch(path, opts)
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => { if (!cancelled) setData(json) })
      .catch(() => { if (!cancelled) setData(null) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [path]) // opts is a static literal per call site, not a reactive dependency

  return { data, loading }
}
